import React, {useContext} from 'react';
import {Button, Space} from 'antd';
import {observer} from "mobx-react";
import {useNavigate, useParams} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import AccessUtil from "../../../components/util/access.util";
import * as ModuleComponent from "../../../moduleComponents";
import {StoreContext} from "../../../store.context";
import {ActionEnum, TranslationDomainEnum} from "../../../types/enums";
import {CardStyled} from "../../../components/styled/card.styled";

export const ViewAgencies: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { servicerStore: { viewAgencies }},
    }} = useContext(StoreContext);

    const { id } : { id: any } = useParams() as any;
    const navigate = useNavigate();

    return (
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <CardStyled title={<Translate message={`servicer.title.agencies`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />}>
                <ModuleComponent.ListTable
                    module={`agency`}
                    dataLoader={ viewAgencies }
                    headers={[
                        'name', 'tpNumber', 'addressString', 'active'
                    ]}
                    actions={[ ActionEnum.VIEW ]}
                />
            </CardStyled>

            <ButtonBar>
                <AccessUtil access={{ routeName: 'servicer_edit', attributes: [{ id }]}}>
                    <Space>
                        <Button type={`primary`} onClick={ () => navigate(`/servicer/${id}/edit`) }>
                            <Translate message={`global.button.edit`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <AccessUtil access={{ routeName: 'servicer_list', attributes: []}}>
                    <Space>
                        <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/servicer`) }>
                            <Translate message={`global.button.back_to_list`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <AccessUtil access={{ routeName: 'servicer_view_history', attributes: [{ id }]}}>
                    <Space>
                        <Button type={`primary`} className={`ant-btn-secondary`} onClick={ () => navigate(`/servicer/${id}/view_history`) }>
                            <Translate message={`global.button.view_history`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <AccessUtil access={{ routeName: 'servicer_view', attributes: [{ id }]}}>
                    <Space>
                        <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/servicer/${id}/view`) }>
                            <Translate message={`global.button.view_servicer`} />
                        </Button>
                    </Space>
                </AccessUtil>
            </ButtonBar>
        </Space>
    )
})